$( $ => {
  const accordion = $( '.bs-section--pricing-features-table .table-container' );
  if( accordion.length ) {
    $( accordion ).find( 'h3' ).click( function(){
      $( this ).parent().toggleClass( 'table-container--hide' );
      $( this ).next( '.table-data-wrapper' ).slideToggle();
    } );
  }
} );
